import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {SocketReconnectionToastData, ToastId} from '@mintdata-wsp/common/state/ui/visualDesigner/ToastData';
import {ProgressBar} from '@mintdata-wsp/wsp/ui/components/general/ProgressBar';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {when} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SocketReconnectionToast.less');
const cx = classnames.bind(styles);

export interface ISocketReconnectionToastProps
{
    toast:SocketReconnectionToastData;
    onClose:(toastId:ToastId) => void;
    onAutoHide:(toastId:ToastId) => void;
}

@observer
export class SocketReconnectionToast extends React.Component<ISocketReconnectionToastProps>
{
    public componentDidMount()
    {
        const {toast, onAutoHide} = this.props;

        when(
            () => !toast.networkState.isSocketReconnecting,
            () => onAutoHide(toast.id)
        );
    }

    public render():JSX.Element
    {
        const {toast} = this.props;
        const {networkState} = toast;

        if( networkState.isFetchingLatestDesign )
            return this._renderFetchingLatestDesign();

        if( networkState.isSocketReconnecting )
            return this._renderReconnecting();

        return this._renderReconnected();
    }

    private _renderReconnecting():JSX.Element
    {
        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconFailed')} />
                    <div className={cx('title')}>
                        {'The connection has been lost'}
                    </div>
                </div>
                <div className={cx('body')}>
                    <div className={cx('message')}>{'Attempting to reconnect...'}</div>
                    <ProgressBar
                        progressTrackClassName={cx('progressTrackClassName')}
                    />
                </div>
            </div>
        );
    }

    private _renderFetchingLatestDesign():JSX.Element
    {
        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconFailed')} />
                    <div className={cx('title')}>
                        {'The connection has been lost'}
                    </div>
                </div>
                <div className={cx('body')}>
                    <div className={cx('message')}>{'Fetching the latest design...'}</div>
                    <ProgressBar
                        progressTrackClassName={cx('progressTrackClassName')}
                    />
                </div>
            </div>
        );
    }

    private _renderReconnected():JSX.Element
    {
        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconSuccess')} />
                    <div className={cx('title')}>
                        {'The connection has been restored'}
                    </div>
                </div>
                <div className={cx('footer')}>
                    <WSPButton
                        className={cx('button')}
                        style={ButtonStyle.Raised}
                        caption={'Ok, got it'}
                        onClick={this._handleCloseButtonClick}
                    />
                </div>
            </div>
        );
    }

    @bind
    private _handleCloseButtonClick()
    {
        const {toast, onClose} = this.props;

        onClose(toast.id);
    };

}
